var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "background",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "rotate(-45 20 20)",
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1421 5.85786C41.9526 13.6684 41.9526 26.3317 34.1421 34.1421C26.3316 41.9526 13.6683 41.9526 5.85786 34.1421L7.27208 32.7279C14.3015 39.7574 25.6985 39.7574 32.7279 32.7279C39.7574 25.6985 39.7574 14.3015 32.7279 7.27208L34.1421 5.85786Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.85787 34.1421C-1.95262 26.3316 -1.95262 13.6683 5.85787 5.85786C13.6684 -1.95262 26.3317 -1.95262 34.1421 5.85787L32.7279 7.27208C25.6985 0.242642 14.3015 0.242641 7.27208 7.27208C0.242644 14.3015 0.242643 25.6985 7.27208 32.7279L5.85787 34.1421Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M32.7279 7.27208L7.27208 32.7279L10.949 26.2225L24.9497 12.2218L32.7279 7.27208Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M32.7279 7.27208L7.27208 32.7279L13.7775 29.051L27.7782 15.0503L32.7279 7.27208Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRound);
export default __webpack_public_path__ + "static/media/round.ac93dd37b8696dabcef2f3642c967dc3.svg";
export { ForwardRef as ReactComponent };